import React from "react";
import HeaderTitleContent from "../../../common/components/atom/HeaderTitleContent/HeaderTitleContent";
import HardwareList from "../../../features/hardwares/components/HardwareList";
import SectionTitle from "../../../common/components/atom/SectionTitle/SectionTitle";
import PageContent from "../../../common/components/atom/PageContent/PageContent";

export default function HardwareListPage() {
  return (
    <PageContent>
      <HeaderTitleContent>Hardwares</HeaderTitleContent>
      <HardwareList.AppNewButtonModal />
      <div style={{ height: 50 }} />
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <SectionTitle iconType={"ship"}>Liste des hardwares</SectionTitle>
      </div>
      <HardwareList.List />
    </PageContent>
  );
}
